import React from "react";
import { useState, useMemo, useEffect } from "react";
import ListTable from "../../utils/Table";
import {
	all_role_list,
} from "../../../actions/Masters/roleList";
import { useDispatch, useSelector } from "react-redux";
import Import from "../../utils/Import";
import { useLocation,useNavigate } from "react-router-dom";
import Export from "../../utils/Export";
export default function UserRole() {
	const dispatch = useDispatch();
	const location = useLocation();
	const navigate = useNavigate()
	const [isEdit, setIsEdit] = useState(false);
	const [form, setForm] = useState((location?.state?.form && JSON.parse(location?.state?.form)) || {});
	const [view, setView] = useState(location?.state?.view || "view_all");
	useMemo(() => {
		if (isEdit) {
			setView("create_new");
		} else {
			setView("view_all");
			setForm({});
		}
	}, [isEdit]);
		const path = location?.pathname.split("/")[3]
	useEffect(() => {
		setView(path != "UserRole" ? "create_new" : "view_all");
		setForm((location?.state?.form && JSON.parse(location?.state?.form)) || {});
		setIsEdit(path == "EditUserRole");
	}, [location]);
	const [tableData, setTableData] = useState({
		tableTitle: "User Role",
		disableDelete: true,
		// deleteRecord: cast_delete,
		// updateRecord: cast_update,
		
		onDeleteText: "Are you sure want to delete the Unit ?",
		onUpdateText: "Are you Sure?",
		tableHead: [
			{
				id: "roleName",
				numeric: false,
				disablePadding: true,
				label: "Role Nmae",
			},
			// {
			// 	id: "cast_image",
			// 	label: "Image",
			// 	isImage: true,
			// },
			// {
			// 	id: "cast_type",
			// 	label: "Cast Type",
			// 	isButtonDisplay: true,
			// },
			// {
			// 	id: "edit",
			// 	label: "Update",
			// },
		],
		tableBody: [

		],
		filterColumn: [
			// {
			// 	id: "1",
			// 	title: "Select Cast Type",
			// 	name: "cast_type",
			// 	options: ["Actor", "Actress"],
			// },
		],
	});


	const role_list = useSelector((state) => state.masters.role_list);
	useEffect(() => {
		dispatch(all_role_list());
	}, []);
	useMemo(() => {
		if (role_list?.statuscode == 200) {
			const temp = tableData;
			temp.tableBody = role_list?.data;
			setTableData({ ...temp });
		}
	}, [role_list]);


	return (
		<>
			{view == "view_all" && (
				<ListTable
					tableData={tableData}
					key={"ListTable"}
					setForm={setForm}
					setTableData={setTableData}
					setIsEdit={setIsEdit}
					create_new={"/Masters/UserRole/EditUserRole"}
				/>
			)}
		</>
	);
}
